import { createFeatureSelector } from '@ngrx/store';

export const modalsState = createFeatureSelector<OLO.State, OLO.State.Modals>('modals');
